<template>
  <div class="saveUpdate">
    <el-dialog
      :close-on-click-modal="false"
      title="监控处理"
      :visible.sync="showDialog"
      @close="$emit('update:showUpdate', false)"
      :showUpdate="showUpdate"
      width="600px"
    >
      <el-form :model="DetailInfo" ref="saveChn" label-width="120px" size="mini">
        <dialog-wrapper :MaxWidth="500">
          <el-row>
            <el-col :span="10">
              <el-form-item label="发送方："><span>{{Detail.source_user.nickname}}</span></el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="接收方：">{{Detail.target_user.nickname}}</el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="监控类型：">{{$store.state.app.sensitiveType[Detail.sensitive_type]}}</el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="监控时间：">{{Detail.created_at}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="监控内容：">
                <span v-if="Detail.sensitive_type">{{Detail.info}}</span>
                <span v-else style="color:#080;cursor:pointer" @click="openImg(Detail.info)">【图片】</span>
              </el-form-item>
              <!--              <el-form-item-->
              <!--                label="所属商户："-->
              <!--              >{{Detail.from_agency?Detail.target_user.platform.name:Detail.source_user.platform.name}}</el-form-item>-->
            </el-col>
            <el-col :span="10">
              <el-button  type="text" @click="showImInfo">查看聊天详情</el-button>
            </el-col>
          </el-row>
          <el-form-item label="处理状态：" prop="desc">
            <div style="color: red">{{this.$store.state.app.wordsTatus[Detail.status]}}</div>
            <!--            <el-input type="textarea" :rows="8" v-model="DetailInfo.desc" width="200px"></el-input>-->
          </el-form-item>
          <el-form-item v-if="id" label="处罚备注：" prop="desc" >
            <div >{{Detail.desc}}</div>
            <!--            <el-input type="textarea" :rows="8" v-model="DetailInfo.desc" width="200px"></el-input>-->
          </el-form-item>
        </dialog-wrapper>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="id" @click="$emit('update:showUpdate', false)" size="small" style="margin-right: 40px">关 闭</el-button>
        <el-button
          v-if="!id"
          type="primary"
          :loading="loading"
          @click="through"
          size="small"
        >通 过</el-button>
        <el-button v-if="!id" type="warning" :loading="loading" style="margin-left: 100px; margin-right: 150px" @click="saveDetail" size="small">处 罚</el-button>
      </div>
      <el-dialog
        width="30%"
        title=""
        :visible.sync="innerVisible"
        append-to-body>
        <el-form :model="DetailInfo" ref="saveChn" label-width="120px" size="mini">
          <el-form-item label="处罚备注：" prop="desc" :rules="[{ required: true, message: '处罚备注不能为空'}]">
            <el-input type="textarea" :rows="6" v-model="DetailInfo.desc" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false" size="small">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="submit"
            size="small"
          >确 定
          </el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <service-iframe
      v-if="showServiceIframe"
      :showServiceIframe.sync="showServiceIframe"
      :ImInfo="ImInfo"
    ></service-iframe>
  </div>
</template>

<script>
import DialogWrapper from "@/components/DialogWrapper";
import { putSensitiveTopics} from "@/api";
import { openURL } from "@/api/img.js";
import serviceIframe from "./serviceIframe";

export default {
  components: { DialogWrapper, serviceIframe },
  data() {
    return {
      innerVisible: false,
      setbank: false,
      showDialog: this.showUpdate,
      showServiceIframe: false,
      loading: false,
      DetailInfo: {},
      ImInfo: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  props: {
    showUpdate: {
      type: Boolean,
      default: false
    },
    Detail: {
      type: Object
    },
    BulletinType: {
      type: Object
    },
    settleCycle: {
      type: Object
    },
    MerchantsList: {
      type: Array
    },
    id: {
      type: Number
    }
  },

  created() {
    if (this.id) {
      // this.getDetail();
    }
  },
  methods: {
    showImInfo() {
      this.topicId = this.Detail.topic_id;
      this.ImInfo = this.Detail.from_agency
        ? {
          agency_id: this.Detail.source_user.id,
          mch_id: this.Detail.target_user.platform.id,
          user_id: this.Detail.target_user.id,
          sensitive_words: this.Detail.sensitive_words.split(','),
          num: 1
        }
        : {
          agency_id: this.Detail.target_user.id,
          mch_id: this.Detail.source_user.platform.id,
          user_id: this.Detail.source_user.id,
          sensitive_words: this.Detail.sensitive_words.split(','),
          num: 1
        };
      this.showServiceIframe = true;
    },
    openImg(item) {
      const key = item.split("?")[0];
      openURL(key);
    },
    through() {
      this.$confirm('确定要通过这次对话吗', '通过', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
      })
        .then(() => {
          putSensitiveTopics(
            this.Detail.id,
            { status: 1}
          ).then(res => {
            if (res.status === 0) {
              this.$message({ message: "已通过", type: "success" });
              this.$emit("update:showUpdate", false);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    submit() {
      this.$refs.saveChn.validate(valid => {
        if (valid) {
          putSensitiveTopics(
            this.Detail.id,
            Object.assign({ status: 2 }, this.DetailInfo)
          ).then(res => {
            if (res.status === 0) {
              this.$message({ message: "处理成功。", type: "success" });
              this.innerVisible = false;
              this.$emit("update:showUpdate", false);
            }
          });
        }
      });
    },
    saveDetail() {
      this.innerVisible = true
    },

    getDetail() {
    }
  },
  watch: {
    showUpdate() {
      this.showDialog = this.showUpdate;
    }
  }
};
</script>


<style scoped>
.pickerStyle {
  width: 280px !important;
}
</style>
